function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_797_1500)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.5187 3.98C20.0138 3.6725 9.98 3.67375 5.48125 3.98C0.61 4.3125 0.03625 7.255 0 15C0.03625 22.7313 0.605 25.6863 5.48125 26.02C9.98125 26.3263 20.0138 26.3275 24.5187 26.02C29.39 25.6875 29.9638 22.745 30 15C29.9638 7.26875 29.395 4.31375 24.5187 3.98ZM11.25 20V10L21.25 14.9913L11.25 20Z",
  fill: "url(#paint0_linear_797_1500)"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11 20V10L21.5 15L11 20Z",
  fill: "white",
  stroke: "white",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_797_1500",
  x1: 6.92963e-8,
  y1: 15,
  x2: 29.9994,
  y2: 14.865,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1D4ED8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A855F7"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_797_1500"
}, /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 30,
  fill: "white"
})));

function SvgHowLaunchpadWorksVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowLaunchpadWorksVideoIcon);
export default __webpack_public_path__ + "static/media/howLaunchpadWorksVideoIcon.3a1a0e74fd6308f2993f3bb84a94a98c.svg";
export { ForwardRef as ReactComponent };